import { Text } from '@shared/components';
import { QuoteTrailRoute } from '@shared/types/quote-event';
import { PiArrowRightBold } from 'react-icons/pi';

interface AuditTrailLaneSnippetProps {
  route: QuoteTrailRoute;
  originatorName: string;
  pickupDate: string;
}

const AuditTrailLaneSnippet = ({
  route,
  originatorName,
  pickupDate,
}: AuditTrailLaneSnippetProps) => {
  return (
    <div className="select-none border-b-2 border-solid border-gray-200 py-2">
      <Text type="body-xs" className="text-gray-700">
        {pickupDate}
      </Text>
      <Text isHeavy={true} type="body-xs" className="text-gray-700">
        {originatorName}
      </Text>
      <div className="flex items-center justify-items-start">
        <Text type="body-xs" isHeavy={true} className="text-gray-700">
          {`${route.pickup.city}, ${route.pickup.state}`}
        </Text>
        <div className="flex w-6 items-center justify-center">
          <PiArrowRightBold size={12} />{' '}
        </div>
        <Text type="body-xs" isHeavy={true} className="text-gray-700">
          {`${route.destination.city}, ${route.destination.state}`}
        </Text>
      </div>
    </div>
  );
};

export default AuditTrailLaneSnippet;
